__turbopack_context__.v({
  "content": "index-module-scss-module__0t1nRW__content",
  "findUs": "index-module-scss-module__0t1nRW__findUs",
  "icon": "index-module-scss-module__0t1nRW__icon",
  "note": "index-module-scss-module__0t1nRW__note",
  "subTitle": "index-module-scss-module__0t1nRW__subTitle",
  "title": "index-module-scss-module__0t1nRW__title",
});
